<template>
  <f7-page
    name="home"
    @page:init="onPageInit"
    ptr
    :ptr-mousewheel="true"
    @ptr:refresh="loadMore"
  >
    <!-- Top Navbar -->
    <f7-navbar>
      <f7-nav-left>
        <f7-button fill @click="qiehuanbus()">切换</f7-button></f7-nav-left
      >
      <f7-nav-title>可派外卖</f7-nav-title>
      <langButton></langButton>
    </f7-navbar>
    <f7-block class="text-align-center" v-if="!isWeiXin()">
      暂不支持微信以外浏览器
    </f7-block>
    <f7-card class="facebook-card" outline v-if="shopInfo">
      <f7-card-header class="no-border">
        <div class="facebook-avatar">
          <div
            v-if="shopInfo.Cover != null && shopInfo.Cover != ''"
            class="coverimg"
            :style="{
              backgroundImage: 'url(' + baseCoverUrl + shopInfo.Cover + ')',
            }"
          ></div>
        </div>
        <div class="zhong">
          <div class="facebook-name">
            {{ $field(shopInfo.Name) }}
          </div>
          <div class="facebook-date">{{ shopInfo.Cellphone }}</div>
        </div>
        <div class="quanz" @click="sheetOpened = true">
          <p>
            权重
            {{ shopInfo.Weight }}
          </p>
        </div>
      </f7-card-header>
      <f7-card-content>
        {{ $field(shopInfo.Intro) }}
      </f7-card-content>
      <f7-card-footer> {{ shopInfo.Address }} </f7-card-footer>
    </f7-card>
    <f7-list inset v-if="shopInfo">
      <f7-list-item link="/CashFlow" :title="$t('balance')">
        <template #after>
          <div class="text_red">s${{ shopInfo.Balance }}</div>
        </template>
      </f7-list-item>
      <f7-list-item link="/ShopPayout" title="余额提款"> </f7-list-item>
      <f7-list-item :link="`/TourDiyTab/${shopInfo.Eid}/`" title="订单管理">
      </f7-list-item>
      <f7-list-item link="/Product" title="产品管理"> </f7-list-item>
    </f7-list>
    <f7-sheet
      :opened="sheetOpened"
      @sheet:closed="sheetOpened = false"
      swipe-to-close
      backdrop
    >
      <f7-page-content>
        <f7-block-title large>权重得分计算说明</f7-block-title>
        <f7-block>
          权重得分根据商户资料完整度、推文、满减营销力度、最近一周订单量等计算得出，客户默认综合排序展示将按照权重排序，权重分数每日凌晨自动更新计算。
        </f7-block>
      </f7-page-content>
    </f7-sheet>
  </f7-page>
</template>
<script>
import wxsdk from "util/wxsdk"; //引入sdk.js
import util from "util/date";
import { base, getShopInfo, getShopData, getUserBusiness } from "@/api/api";
import { f7 } from "framework7-vue";
export default {
  props: {
    f7router: Object,
  },
  data() {
    return {
      baseCoverUrl: base + "/FileUpload/ShopCover/b0/",
      title: null,
      businList: [],
      shopInfo: null,
      sheetOpened: false,
    };
  },
  methods: {
    isWeiXin() {
      return util.isWeiXin();
    },
    loadMore(done) {
      if (window.localStorage.Shop_Id) {
        getShopInfo({
          key: window.localStorage.Shop_Id,
        }).then((res) => {
          this.shopInfo = res.data.response;
          this.title = res.data.response.Name;
          done();
        });
      } else {
        done();
      }
    },
    getShopDataInfo(bid) {
      getShopData({
        bid,
      }).then((res) => {
        f7.preloader.hide();
        if (res.data.success) {
          this.shopInfo = res.data.response;
          this.title = res.data.response.Name;
          f7.store.dispatch("saveShopId", res.data.response.Eid);
          return;
        }
        f7.toast
          .create({
            icon: '<i class="f7-icons">multiply</i>',
            text: res.data.msg,
            position: "center",
            closeTimeout: 2000,
          })
          .open();
      });
    },
    qiehuanbus() {
      getUserBusiness({
        openId: window.localStorage.OpenId,
      }).then((res) => {
        self.businList = res.data.response.businessList;
        if (self.businList == null || self.businList.length <= 0) {
          f7.preloader.hide();
          f7.toast
            .create({
              icon: '<i class="f7-icons">multiply</i>',
              text: "未找到可管理门店",
              position: "center",
              closeTimeout: 2000,
            })
            .open();
          return;
        }
        if (self.businList.length == 1) {
          self.getShopDataInfo(self.businList[0].businessId);
        } else {
          this.qiehuan();
        }
      });
    },
    qiehuan() {
      var self = this;
      var buts = [];
      this.businList.forEach(function (value, index, array) {
        buts.push({ text: self.businList[index].businessName });
      });
      f7.dialog
        .create({
          title: "选择店铺",
          buttons: buts,
          verticalButtons: true,
          onClick: function (dialog, index) {
            self.getShopDataInfo(self.businList[index].businessId);
          },
        })
        .open();
    },
    onPageInit() {
      var self = this;
      if (util.isWeiXin()) {
        if (!window.localStorage.OpenId) {
          this.f7router.navigate("/login");
          return;
        }
        var url = window.location.href.split("#")[0];
        var obj = {
          title: "可派外卖商户端", //分享标题
          desc: "可派外卖商户端", //分享内容
          linkurl: url, //分享链接
          img: "https://shopapi.koipy.com/indeximg.jpg", //分享内容显示的图片
        };
        //wxsdk.getJSSDK(url, obj); //传入sdk.js需要的参数
        f7.preloader.show();
        getUserBusiness({
          openId: window.localStorage.OpenId,
        }).then((res) => {
          self.businList = res.data.response.businessList;
          if (self.businList == null || self.businList.length <= 0) {
            f7.preloader.hide();
            f7.toast
              .create({
                icon: '<i class="f7-icons">multiply</i>',
                text: "未找到可管理门店",
                position: "center",
                closeTimeout: 2000,
              })
              .open();
            return;
          }

          if (window.localStorage.Shop_Id) {
            getShopInfo({
              key: window.localStorage.Shop_Id,
            }).then((res) => {
              this.shopInfo = res.data.response;
              this.title = res.data.response.Name;
              f7.preloader.hide();
            });
          } else {
            if (self.businList.length == 1) {
              self.getShopDataInfo(self.businList[0].businessId);
            } else {
              this.qiehuan();
              f7.preloader.hide();
            }
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.coverimg {
  width: 60px;
  height: 60px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 3px;
}
.facebook-card .card-header {
  display: flex;
  padding: 10px;
  justify-content: initial;
}
.facebook-card .facebook-avatar {
  width: 60px;
  margin-right: 10px;
}
.facebook-card .facebook-name {
  font-size: 14px;
  font-weight: 500;
}
.facebook-card .facebook-date {
  font-size: 13px;
  color: #8e8e93;
}
.zhong {
  width: calc(100% - 130px);
}
.quanz {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  text-align: center;
  background-color: #fcf1d9;
  color: #e28534;
  border: 2px solid #ffa629;
  font-size: 13px;
}
.balance {
  margin-left: 70px;
  display: flex;
  font-size: 14px;
}
</style>